import { FC, useEffect } from 'react';

import Modal from '@/components/modal';

const AUTO_CLOSE_MS = 3000;

interface ProfileSaveSuccessModalProps {
  title: string;
  message: string;
  onClose: () => void;
}

const ProfileSaveSuccessModal: FC<ProfileSaveSuccessModalProps> = ({
  title,
  message,
  onClose,
}) => {
  useEffect(() => {
    const timeout = setTimeout(onClose, AUTO_CLOSE_MS);

    return () => clearTimeout(timeout);
  }, [onClose]);

  return (
    <Modal
      onClose={onClose}
      showCloseIcon={false}
      contentClassName="!bg-[rgb(43,42,45)] tesn:!bg-[rgb(43,42,45)] teair:!bg-[rgb(43,42,45)] teair:!text-white"
    >
      <div className="px-5 py-10 md:px-10 md:py-12 max-w-[560px] mx-auto text-center">
        <h2 className="text-h3 text-pink mb-4">{title}</h2>

        <p className="text-body2">{message}</p>
      </div>
    </Modal>
  );
};

export default ProfileSaveSuccessModal;
